/* La Paisita — interacciones */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var money = (window.Shopify && Shopify.money_format) || '${{amount}}';

  function fmt(cents) {
    var value = cents / 100;
    function num(v, decimals, thousands, decimalSep) {
      var n = v.toFixed(decimals);
      var parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimalSep + parts[1] : parts[0];
    }
    return money.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount': return num(value, 2, ',', '.');
        case 'amount_no_decimals': return num(value, 0, ',', '.');
        case 'amount_with_comma_separator': return num(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(value, 2, "'", '.');
        case 'amount_no_decimals_with_space_separator': return num(value, 0, ' ', ',');
        case 'amount_with_space_separator': return num(value, 2, ' ', ',');
        default: return num(value, 2, ',', '.');
      }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      ['mnav', 'movl'].forEach(function (id) { var el = document.getElementById(id); if (el) el.classList.remove('open'); });
      closeCart();
    }
  });

  var drawer = $('[data-cart-drawer]');
  var overlay = $('[data-cart-overlay]');
  function openCart() { if (drawer) { drawer.classList.add('open'); if (overlay) overlay.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); if (overlay) overlay.classList.remove('open'); document.body.style.overflow = ''; } }

  $$('[data-cart-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); openCart(); refresh(); } });
  });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  if (overlay) overlay.addEventListener('click', closeCart);

  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function render(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; if (cart.item_count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); } });
    var items = $('[data-cart-items]'); var foot = $('[data-cart-foot]'); var empty = $('[data-cart-empty]');
    if (!items) return;
    if (cart.item_count === 0) { items.innerHTML = ''; if (foot) foot.hidden = true; if (empty) empty.style.display = 'block'; return; }
    if (empty) empty.style.display = 'none';
    if (foot) foot.hidden = false;
    var sub = $('[data-cart-subtotal]'); if (sub) sub.textContent = fmt(cart.total_price);
    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      return '<div class="ci" data-key="' + it.key + '">'
        + '<a href="' + it.url + '" class="ci__img">' + (img ? '<img src="' + img + '" alt="" width="60" height="75">' : '') + '</a>'
        + '<div class="ci__mid"><a href="' + it.url + '" class="ci__title">' + it.product_title + '</a>'
        + (it.variant_title ? '<div class="ci__var">' + it.variant_title + '</div>' : '')
        + '<div class="ci__qty"><button type="button" data-minus aria-label="Menos">-</button><span>' + it.quantity + '</span><button type="button" data-plus aria-label="Mas">+</button></div>'
        + '</div>'
        + '<div class="ci__right"><div class="ci__price">' + fmt(it.final_line_price) + '</div><button type="button" class="ci__rm" data-remove>Quitar</button></div>'
        + '</div>';
    }).join('');
  }

  function refresh() { return getCart().then(render).catch(function () {}); }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      render(cart);
      if (document.querySelector('.cartpage')) window.location.reload();
    });
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest ? e.target.closest('.ci') : null;
    if (!row) return;
    var key = row.getAttribute('data-key');
    var qtyEl = row.querySelector('.ci__qty span');
    var q = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.hasAttribute('data-plus')) change(key, q + 1);
    else if (e.target.hasAttribute('data-minus')) change(key, Math.max(0, q - 1));
    else if (e.target.hasAttribute('data-remove')) change(key, 0);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-quick-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('[data-add]');
    var txt = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Agregando...'; }
    var id = form.querySelector('[name="id"]').value;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () { return refresh(); })
      .then(function () { if (btn) { btn.textContent = 'Agregado!'; } openCart(); setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = txt; } }, 1200); })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = txt; } alert('No pudimos agregar el producto. Intenta de nuevo.'); });
  });

  $$('[data-carousel]').forEach(function (car) {
    var track = $('[data-carousel-track]', car);
    if (!track) return;
    var prev = $('[data-carousel-prev]', car);
    var next = $('[data-carousel-next]', car);
    var pausedUntil = 0, down = false, x0 = 0, s0 = 0, moved = false;
    function pause(ms) { pausedUntil = Date.now() + ms; }
    function step() { return Math.max(240, track.clientWidth * 0.85); }

    if (prev) prev.addEventListener('click', function () { pause(3500); track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { pause(3500); track.scrollBy({ left: step(), behavior: 'smooth' }); });

    track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'touch') return; if (e.button) return; down = true; moved = false; x0 = e.clientX; s0 = track.scrollLeft; });
    track.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 6) { moved = true; track.classList.add('grabbing'); pause(6000); } if (moved) { e.preventDefault(); track.scrollLeft = s0 - dx; } });
    function end() { down = false; track.classList.remove('grabbing'); }
    window.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

    track.addEventListener('mouseenter', function () { pause(9e8); });
    track.addEventListener('mouseleave', function () { pausedUntil = 0; });
    track.addEventListener('touchstart', function () { pause(6000); }, { passive: true });

    var autoAttr = track.getAttribute('data-autoscroll');
    if (autoAttr) {
      var speed = parseFloat(autoAttr) || 0.5;
      var tick = function () {
        if (!down && Date.now() > pausedUntil) {
          track.scrollLeft += speed;
          if (track.scrollLeft >= (track.scrollWidth - track.clientWidth - 1)) track.scrollLeft = 0;
        }
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  });

  var animes = $$('[data-animate]');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
    animes.forEach(function (el) { io.observe(el); });
    setTimeout(function () { animes.forEach(function (el) { el.classList.add('in'); }); }, 1500);
  } else {
    animes.forEach(function (el) { el.classList.add('in'); });
  }

  refresh();
})();
